(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dd-product-posters"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dd-product-posters')) {
  customElements.define('dd-product-posters', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.dd-posters__track');
      this.items = Array.from(this.querySelectorAll('.dd-posters__item'));
      this.controls = this.querySelector('.dd-posters__controls');
      this.previous = this.querySelector('[data-direction="previous"]');
      this.next = this.querySelector('[data-direction="next"]');
      this.status = this.querySelector('.dd-posters__status');
      if (!this.track || !this.items.length) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.goTo(event.key === 'Home' ? 0 : this.items.length - 1);
        }
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('.dd-posters__item');
        if (item) this.goTo(this.items.indexOf(item));
      }, options);
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.track);
      this.update();
    }
    currentIndex() {
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      const trackRect = this.track.getBoundingClientRect();
      const padding = parseFloat(getComputedStyle(this.track).paddingInlineStart) || 0;
      const edge = rtl ? trackRect.right - padding : trackRect.left + padding;
      let nearest = 0;
      let distance = Infinity;
      this.items.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        const delta = Math.abs((rtl ? rect.right : rect.left) - edge);
        if (delta < distance) { distance = delta; nearest = index; }
      });
      return nearest;
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const position = Math.abs(this.track.scrollLeft);
      const overflow = max > 2;
      this.controls.hidden = !overflow;
      this.track.tabIndex = overflow ? 0 : -1;
      this.previous.disabled = position < 2;
      this.next.disabled = position >= max - 2;
      this.status.textContent = `${this.currentIndex() + 1} / ${this.items.length}`;
    }
    move(step) { this.goTo(this.currentIndex() + step); }
    goTo(index) {
      const target = this.items[Math.max(0, Math.min(this.items.length - 1, index))];
      if (!target) return;
      const rect = target.getBoundingClientRect();
      const trackRect = this.track.getBoundingClientRect();
      const style = getComputedStyle(this.track);
      const padding = parseFloat(style.paddingInlineStart) || 0;
      const delta = style.direction === 'rtl' ? rect.right - trackRect.right + padding : rect.left - trackRect.left - padding;
      this.track.scrollBy({ left: delta, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
